import { Injectable } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import {
  CustomField,
  VehicleCreationData,
  VehicleFromVIN,
} from 'src/app/shared/models/vehicle.model';
import {
  HEXValidator,
  VINValidator,
} from 'src/app/shared/utils/validators.util';

@Injectable({
  providedIn: 'root',
})
export class VehiclesLogicService {
  constructor(private fb: FormBuilder) {}

  buildForm(): FormGroup {
    return this.fb.group({
      type: [null, Validators.required],
      vin: [null, [Validators.required, VINValidator]],
      msrp: [0, Validators.required],
      manual_input_switch: [false],
      make: [null, Validators.required],
      model: [null, Validators.required],
      year: [null, Validators.required],
      make_text: [null],
      model_text: [null],
      year_text: [null],
      trim_id: [null, [Validators.required]],
      drive_type: [null, [Validators.required]],
      cylinder: [null, [Validators.required]],
      description: [null],
      customFieldsArr: new FormArray([]),
      fuel_type: [null, Validators.required],
      is_turbo: [false, Validators.required],
      tonnage: [null],
      gross_vehicle_weight_rating: [null],
      engine_aspiration: [null],
      engine_size: [null],
    });
  }

  getCreationData(
    formValue: any,
    vinNumberValid: boolean,
  ): VehicleCreationData {
    const custom_fields: CustomField[] = this.getCustomFieldsValue(formValue);
    const isManualMode = formValue.manual_input_switch;
    
    const payload: any = {
      type_id: formValue.type?.id,
      vin: formValue.vin,
      description: formValue.description,
      year_number: isManualMode ? formValue.year_text : Number(formValue.year),
      trim_id: formValue.trim_id,
      brand_id: isManualMode ? undefined : formValue.make?.id,
      model_id: isManualMode ? undefined : formValue.model?.id,
      brand: isManualMode ? formValue.make_text : undefined,
      model: isManualMode ? formValue.model_text : undefined,
      status: vinNumberValid ? 'validated' : 'draft',
      drive_type: formValue.drive_type,
      cylinder: formValue.cylinder,
      fuel_type: formValue.fuel_type,
      is_turbo: formValue.is_turbo,
      tonnage: formValue.tonnage,
      gross_vehicle_weight_rating: formValue.gross_vehicle_weight_rating,
      engine_aspiration: formValue.engine_aspiration,
      engine_size: formValue.engine_size,
      custom_fields: custom_fields.length ? custom_fields : undefined,
    };

    if (isManualMode) {
      payload.trim = formValue.trim_id;
      delete payload.trim_id;
    }

    if (formValue.msrp != null) {
      payload['msrp'] = formValue.msrp;
    }

    // Remove undefined or null values
    Object.keys(payload).forEach(key => {
      if (payload[key] === undefined || payload[key] === null) {
        delete payload[key];
      }
    });

    return payload;
  }

  getVehicleToPatch(vehicle: VehicleFromVIN): any {
    return {
      ...vehicle,
      is_turbo: !!vehicle.is_turbo,
      type: vehicle?.trim?.model?.brand?.type,
      class: {
        id: vehicle?.class?.id,
        class: vehicle?.class?.class,
      },
      make: vehicle?.trim?.model?.brand,
      model: vehicle?.trim?.model,
      year: vehicle?.trim?.model.year,
      trim_id: vehicle?.trim?.trim,
    };
  }

  private getCustomFieldsValue(formValue: any): CustomField[] {
    return formValue.customFieldsArr
      .map((customField: any) => ({
        attribute_id: customField.id,
        value: customField.content,
      }))
      .filter(
        (field: CustomField) =>
          field.value !== null && field.value !== undefined && field.value !== ''
      );
  }
}
